'use strict';

import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';

class FeatureGrid {
    ui;
    state;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                items: this.wrap.querySelectorAll('.js-feature-grid-item')
            };

            this.setState();
            this.bindUIActions();
        }
    }

    bindUIActions() {
        window.addEventListener('load',   () => this.windowLoad());
        window.addEventListener('scroll', () => this.windowScroll());
        window.addEventListener('resize', () => this.windowResize());
    }

    windowLoad() {
        this.setState();
        this.checkItemVisibility();
    }

    windowScroll() {
        this.checkItemVisibility();
    }

    windowResize() {
        this.setState();
        this.checkItemVisibility();
    }

    setState() {
        this.state = this.state || {};
        this.state.items = this.state.items || [].map.call(this.ui.items, (item) => {
            return {
                el: item,
                visible: item.visible || false
            };
        });

        this.state.items = this.state.items.map((item) => {
            item.pos = item.el.getBoundingClientRect().top + window.pageYOffset;
            return item;
        });

        this.state.windowHeight = window.innerHeight;
    }

    checkItemVisibility() {
        let pageTopPos = window.pageYOffset,
            pageBottomPos = pageTopPos + this.state.windowHeight,
            visibleItems;

        visibleItems = this.state.items.filter(function(item) {
            return (item.visible === false) &&
                pageBottomPos > (item.pos - 20) &&
                pageTopPos < item.pos;
        });

        this.showItems(visibleItems);
    }

    showItems(items) {
        let stagger = 50;

        items.forEach((item) => {
            setTimeout(function() {
                item.el.classList.add('is-visible');
                item.visible = true;
            }, stagger);
            stagger += 100;
        });
    }
}

export default FeatureGrid;
